{
  "legalConfirmLabel": "Chiudi",
  "legalCopyright": "Copyright © {copyrightYears} Adobe Inc. All rights reserved.",
  "legalPrivacyPolicy": "Informativa sulla privacy",
  "legalTermsOfUse": "Condizioni d’uso",
  "legalTermsOfUseLink": "https://www.adobe.com/go/experiencecloudterms_it",
  "profileLegalNoticesMenuItem": "Note legali"
}
